import React from 'react';
import { useTranslation } from 'react-i18next';
import { OPEN_EMS_UI_URL } from '../../utils/openEmsUrls';
import { getB2bBakeryCaseCopy } from './b2bBakeryCaseCopy';
import batteryFigure from './bakery-case-battery.png';
import styles from './B2bSolarCase.module.css';

const BAKERY_EMS_QUERY = 'market=oree&zone=ES&inverter=deye%3A2604060007';

export default function B2bBakeryCase() {
  const { i18n } = useTranslation();
  const copy = getB2bBakeryCaseCopy(i18n.resolvedLanguage || i18n.language);
  const openEmsHref = `${OPEN_EMS_UI_URL.replace(/\/+$/, '')}/?${BAKERY_EMS_QUERY}`;

  return (
    <article className={styles.case}>
      <img className={`${styles.figure} ${styles.figureCompact}`} src={batteryFigure} alt={copy.figureAlt} />
      <h3 className={styles.headline}>{copy.headline}</h3>
      <p className={styles.body}>
        {copy.introBefore}
        <a href={openEmsHref} target="_blank" rel="noopener noreferrer" className={styles.emsLink}>
          {copy.emsName}
        </a>
        {copy.introAfter}
      </p>
      <p className={styles.lead}>{copy.lead}</p>

      <section>
        <h4 className={styles.sectionTitle}>{copy.wasTitle}</h4>
        {copy.wasBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <section>
        <h4 className={styles.sectionTitle}>{copy.changedTitle}</h4>
        {copy.changedBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <section>
        <h4 className={styles.sectionTitle}>{copy.decisionTitle}</h4>
        {copy.decisionBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <section>
        <h4 className={styles.sectionTitle}>{copy.betterTitle}</h4>
        {copy.betterBody.map(text => (
          <p key={text} className={styles.body}>
            {text}
          </p>
        ))}
      </section>

      <p className={styles.source}>
        <a href={openEmsHref} target="_blank" rel="noopener noreferrer" className={styles.emsLink}>
          {copy.source}
        </a>
      </p>
    </article>
  );
}
